import hasTag from '@/server/helpers/hasTag';

const getIsUbtcEnabled = async (walletCurrency: CashierCurrency) => {
  if (walletCurrency === 'BTC') {
    return hasTag('uBTC');
  }
  return false;
};

export default getIsUbtcEnabled;
